import { trans } from '@/domain/dao/Translations';
import { useApi } from './VideoThumbnailSelector.api';
import { useModal } from '@/lib/Modal/useModal';
import { ref, Ref, SetupFunction } from 'vue';
import { VideoThumbnailEmitters, VideoThumbnailEvents } from '@/lib/components/Uploader/VideoThumbnailModal.events';

type Props = {
	selected: string | null;
	fileToken: string;
};

type View = {
	selected: Ref<string | null>;
	labels: {
		select: string;
		save: string;
		cancel: string;
	};
	visible: Ref<boolean>;
	show: () => void;
	onConfirmed: () => void;
	onClosed: () => void;
	onThumbnailSelected: (thumbnail: string | null) => void;
	thumbnails: Ref<string[]>;
	isSaving: Ref<boolean>;
};

const videoThumbnailModalController: SetupFunction<Props, View, VideoThumbnailEmitters> = (props, { emit }): View => {
	const { visible, show, onConfirmed, onClosed, isSaving } = useModal('videoThumbnailModal', emit, {
		onConfirm: async () => {
			emit(VideoThumbnailEvents.ThumbnailSelected, selected.value);
		},
		onShow: async () => {
			thumbnails.value = await useApi(props.fileToken).availableThumbnails();
		},
	});

	const selected = ref<string | null>(props.selected);
	const thumbnails = ref<string[]>([]);

	const labels = {
		select: trans().get('files.buttons.select_thumbnail'),
		save: trans().get('buttons.save'),
		cancel: trans().get('buttons.cancel'),
	};

	const onThumbnailSelected = (thumbnail: string | null) => {
		selected.value = thumbnail;
	};

	return {
		selected,
		labels,
		onClosed,
		onThumbnailSelected,
		thumbnails,
		isSaving,
		visible,
		show,
		onConfirmed,
	};
};

export { Props, View, videoThumbnailModalController };
